[
  {
    "idInteracao": "MEM_001",
    "data": "3/25/21",
    "clienteId": "CLI_0003",
    "cliente": "2",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Objetivo declarado",
    "informacaoAprendida": "Disse que quer organizar alimentação da semana.",
    "valorEstruturado": "organizar_semana",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil fiel | valor típico"
  },
  {
    "idInteracao": "MEM_002",
    "data": "3/24/21",
    "clienteId": "CLI_0004",
    "cliente": "3",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Rotina declarada",
    "informacaoAprendida": "Disse que come 5 refeições por semana em casa.",
    "valorEstruturado": "5_refeicoes_casa",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Média",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil fiel | valor típico"
  },
  {
    "idInteracao": "MEM_003",
    "data": "3/23/21",
    "clienteId": "CLI_0005",
    "cliente": "4",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Restrição alimentar",
    "informacaoAprendida": "Declarou intolerância à lactose.",
    "valorEstruturado": "sem_lactose",
    "nivelDeSensibilidade": "Média",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil fiel | valor típico"
  },
  {
    "idInteracao": "MEM_004",
    "data": "3/22/21",
    "clienteId": "CLI_0009",
    "cliente": "8",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Restrição alimentar",
    "informacaoAprendida": "Declarou preferência low carb.",
    "valorEstruturado": "low_carb",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil fiel | valor típico"
  },
  {
    "idInteracao": "MEM_005",
    "data": "3/21/21",
    "clienteId": "CLI_0006",
    "cliente": "5",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Preferência de sabor",
    "informacaoAprendida": "Prefere proteína magra (frango).",
    "valorEstruturado": "proteina_frango",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Média",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil recorrente | valor típico"
  },
  {
    "idInteracao": "MEM_006",
    "data": "3/20/21",
    "clienteId": "CLI_0011",
    "cliente": "10",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Interesse em assinatura",
    "informacaoAprendida": "Demonstrou interesse em assinatura mensal.",
    "valorEstruturado": "interesse_assinatura",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil recorrente | valor típico"
  },
  {
    "idInteracao": "MEM_007",
    "data": "3/19/21",
    "clienteId": "CLI_0013",
    "cliente": "12",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Interesse em acompanhamento calórico",
    "informacaoAprendida": "Quer acompanhar calorias semanais.",
    "valorEstruturado": "interesse_calorico",
    "nivelDeSensibilidade": "Média",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil recorrente | valor típico"
  },
  {
    "idInteracao": "MEM_008",
    "data": "3/18/21",
    "clienteId": "CLI_0021",
    "cliente": "20",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Canal preferido",
    "informacaoAprendida": "Prefere ser contatado pelo WhatsApp.",
    "valorEstruturado": "whatsapp",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil recorrente | valor típico"
  },
  {
    "idInteracao": "MEM_009",
    "data": "3/17/21",
    "clienteId": "CLI_0002",
    "cliente": "1",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Horário preferido",
    "informacaoAprendida": "Prefere receber à tarde.",
    "valorEstruturado": "tarde",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Média",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil novo | valor típico"
  },
  {
    "idInteracao": "MEM_010",
    "data": "3/16/21",
    "clienteId": "CLI_0007",
    "cliente": "6",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Objetivo declarado",
    "informacaoAprendida": "Disse que quer comprar marmitas para a família.",
    "valorEstruturado": "familia",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil novo | valor típico"
  },
  {
    "idInteracao": "MEM_011",
    "data": "3/15/21",
    "clienteId": "CLI_0008",
    "cliente": "7",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Objetivo declarado",
    "informacaoAprendida": "Disse que compra para equipe da empresa.",
    "valorEstruturado": "equipe",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil novo | valor típico"
  },
  {
    "idInteracao": "MEM_012",
    "data": "3/14/21",
    "clienteId": "CLI_0183",
    "cliente": "182",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Reclamação",
    "informacaoAprendida": "Reclamou de atraso em pedido anterior.",
    "valorEstruturado": "atraso_entrega",
    "nivelDeSensibilidade": "Média",
    "consentimentoRegistrado": "N/A",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil fiel | valor típico"
  },
  {
    "idInteracao": "MEM_013",
    "data": "3/13/21",
    "clienteId": "CLI_0189",
    "cliente": "188",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Elogio",
    "informacaoAprendida": "Elogiou sabor das marmitas.",
    "valorEstruturado": "elogio_sabor",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "N/A",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil recorrente | valor típico"
  },
  {
    "idInteracao": "MEM_014",
    "data": "3/12/21",
    "clienteId": "CLI_0195",
    "cliente": "194",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Quantidade de refeições por semana",
    "informacaoAprendida": "Mencionou comprar marmitas para almoço de toda a semana.",
    "valorEstruturado": "semana_completa",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Média",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil recorrente | valor típico"
  },
  {
    "idInteracao": "MEM_015",
    "data": "3/11/21",
    "clienteId": "CLI_0198",
    "cliente": "197",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Dúvida frequente",
    "informacaoAprendida": "Pergunta com frequência sobre cardápio do dia.",
    "valorEstruturado": "cardapio_dia",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "N/A",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil recorrente | valor típico"
  },
  {
    "idInteracao": "MEM_016",
    "data": "3/10/21",
    "clienteId": "CLI_0037",
    "cliente": "36",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Objetivo declarado",
    "informacaoAprendida": "Disse que quer evitar pedir comida fora.",
    "valorEstruturado": "evitar_delivery",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil novo | valor alto"
  },
  {
    "idInteracao": "MEM_017",
    "data": "3/9/21",
    "clienteId": "CLI_0258",
    "cliente": "257",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Objetivo declarado",
    "informacaoAprendida": "Quer controlar melhor a rotina alimentar.",
    "valorEstruturado": "controlar_rotina",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil fiel | valor alto"
  },
  {
    "idInteracao": "MEM_018",
    "data": "3/8/21",
    "clienteId": "CLI_0287",
    "cliente": "286",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Interesse em acompanhamento calórico",
    "informacaoAprendida": "Quer registrar calorias consumidas semanalmente.",
    "valorEstruturado": "registro_calorias",
    "nivelDeSensibilidade": "Média",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil novo | valor alto"
  },
  {
    "idInteracao": "MEM_019",
    "data": "3/7/21",
    "clienteId": "CLI_0032",
    "cliente": "31",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Preferência de sabor",
    "informacaoAprendida": "Gosta de pratos da culinária nordestina.",
    "valorEstruturado": "culinaria_nordestina",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Média",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil fiel | valor típico"
  },
  {
    "idInteracao": "MEM_020",
    "data": "3/6/21",
    "clienteId": "CLI_0040",
    "cliente": "39",
    "origem": "Chat simulado",
    "tipoDeInformacao": "Objetivo declarado",
    "informacaoAprendida": "Comprou para a equipe — pedido coletivo confirmado.",
    "valorEstruturado": "coletivo_confirmado",
    "nivelDeSensibilidade": "Baixa",
    "consentimentoRegistrado": "Sim",
    "fonte": "Simulado para protótipo",
    "nivelDeConfianca": "Alta",
    "validadeDaInformacao": "90 dias",
    "podeUsarParaPersonalizar": "Sim (após consentimento)",
    "observacao": "Coerente com perfil fiel | valor típico"
  }
]